export default from 'redux-actions/lib/createAction';



// WEBPACK FOOTER //
// ./app/services/create-action.js